// extracted by mini-css-extract-plugin
export var blend = "Figure-module--blend--ef98a";
export var caption = "Figure-module--caption--bb6f8";
export var root = "Figure-module--root--09160";